import './theme/tailwind.css';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import 'react-toastify/dist/ReactToastify.min.css';

import ReactDOM from 'react-dom';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';

import LanguageProvider from 'providers/LanguageProvider';
import LocationHistoryProvider from 'providers/LocationHistoryProvider';
import NotificationProvider from 'providers/NotificationProvider';
import TailwindProvider from 'providers/TailwindProvider';
import UserProvider from 'providers/UserProvider';

import initSentry from 'utils/initSentry';
import queryClient from 'utils/queryClient';

import { toastClassnameIdentifierId } from 'utils/dataTestIds';
import App from './app/App';

initSentry();

if (
  process.env.NODE_ENV !== 'production' &&
  process.env.REACT_APP_HIDE_OVERLAY
) {
  // eslint-disable-next-line import/no-extraneous-dependencies
  import('hide-cra-error-overlay').then(({ initHideOverlay }) =>
    initHideOverlay(),
  );
}

if (
  process.env.NODE_ENV === 'development' &&
  process.env.REACT_APP_MOCK === 'true'
) {
  // eslint-disable-next-line global-require
  const { worker } = require('./mocks/browser');
  void worker.start();
}

if (process.env.NODE_ENV === 'production') {
  // eslint-disable-next-line no-console
  console.log(`
    =============================================================================================
    __________________________ ________ ________ __________
    ___  ____/___  __/___  __ \\___  __ \\___  __ \\___  ____/
    __  /_    __  /   __  /_/ /__  /_/ /__  /_/ /__  /_
    _  __/    _  /    _  _, _/ _  ____/ _  _, _/ _  __/
    /_/       /_/     /_/ |_|  /_/      /_/ |_|  /_/    v${process.env.REACT_APP_VERSION}
    =============================================================================================
    `);

  // eslint-disable-next-line no-console
  console.log(
    'Wanted: Passionate developers. React / Java Spring Boot. Send a mail to katelijne@ftrprf.be with your CV and motivation!',
  );

  window.console = {
    error: () => {},
    info: () => {},
    log: () => {},
    warn: () => {},
  };
}

ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <UserProvider>
      <LanguageProvider>
        <TailwindProvider>
          {process.env.NODE_ENV === 'development' && (
            <ReactQueryDevtools initialIsOpen={false} />
          )}
          <Router>
            <QueryParamProvider
              adapter={ReactRouter6Adapter}
              options={{
                removeDefaultsFromUrl: true,
                updateType: 'replaceIn',
              }}
            >
              <LocationHistoryProvider>
                <ToastContainer
                  newestOnTop
                  pauseOnHover
                  toastClassName={toastClassnameIdentifierId}
                />
                <NotificationProvider>
                  <App />
                </NotificationProvider>
              </LocationHistoryProvider>
            </QueryParamProvider>
          </Router>
        </TailwindProvider>
      </LanguageProvider>
    </UserProvider>
  </QueryClientProvider>,
  document.getElementById('root'),
);
